// @flow

import React from 'react';

/**
 * RouteConfigContext
 * creates the context for route configs
 */
export const RouteConfigContext: Object = React.createContext({});
